import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Импортируем хук перевода
import PaginationComponent from "components/UI/Pagination/PaginationComponent";
import DecreesCard from "../DecreesCard/DecreesCard";
import Empty from "components/Empty/Empty";

import classes from "./decreesList.module.scss";
import { PATHS, HOST, } from "common/constants";

const GetRightList = ({ decrees, acts, actsActive }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || "ky"; // Получаем текущий язык (по умолчанию ky)

  if (!actsActive) {
    return (
      decrees?.map((item, i) => {
        // Если у decrees тоже есть локализованные поля (например, description_ru/ky), 
        // используем такую же логику:
        const description = item[`description_${currentLang}`] || item.description || "";
        
        return (
          <DecreesCard
            key={i}
            number={item.number}
            text={description}
            date={item.created_at}
            link={item.file}
          />
        );
      })
    );
  }

  return (
    acts?.map((item, i) => {
      // Динамически выбираем поле: title_ru, title_ky или title_en
      // Если выбранное поле пустое, берем title_ru как запасной вариант
      const displayTitle = item[`title_${currentLang}`] || item.title_ru || item.title;

      return (
        <DecreesCard
          key={i}
          number={item.act_number}
          text={displayTitle}
          link={item.link}
          acts
        />
      );
    })
  );
};

const DecreesList = ({ actsActive = false }) => {
  const location = useLocation();
  const { i18n } = useTranslation(); // Следим за изменением языка
  const [decrees, setDecrees] = useState([]);
  const [acts, setActs] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const offset = 10;

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (actsActive) {
          const res = await axios.get(`${HOST}/api/v1/acts/`, {
            params: { limit: offset, offset: (page - 1) * offset },
          });
          setActs(res.data.results);
          setCount(res.data.count);
        } else {
          const res = await axios.get(`${HOST}/api/v1/places/`, {
            params: { limit: offset, offset: (page - 1) * offset },
          });
          setDecrees(res.data.results);
          setCount(res.data.count);
        }
      } catch (err) {
        console.error("Ошибка при загрузке данных:", err);
      }
    };

    fetchData();
  }, [actsActive, page, i18n.language]); // Добавили i18n.language в зависимости, чтобы данные могли обновиться при смене языка

  const lengthItems = Math.ceil(count / offset);

  return (
    <>
      <Box className={classes.wrapper}>
        <GetRightList
          acts={acts}
          decrees={decrees}
          actsActive={actsActive}
        />
        {location.pathname === PATHS?.decrees && !decrees.length && <Empty />}
        {location.pathname === PATHS?.legislation && !acts.length && <Empty />}
      </Box>
      <PaginationComponent page={page} setPage={setPage} length={lengthItems} />
    </>
  );
};

export default DecreesList;